var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('v-btn',{attrs:{"icon":"","small":"","title":"Third Party Sync","loading":_vm.loading},on:{"click":function($event){$event.stopPropagation();return _vm.toggle(_vm.item)}}},[_c('v-icon',{attrs:{"small":"","color":_vm.color}},[_vm._v("mdi-moped")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }